import { Component, OnInit } from '@angular/core';
import { GAccsessService } from 'src/app/services/g-accsess.service';
import { DatePipe } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { MainComponent } from '../main/main.component';

@Component({
  selector: 'app-add-member',
  templateUrl: './add-member.component.html',
  styleUrls: ['./add-member.component.css']
})
export class AddMemberComponent implements OnInit {

  chooseType: any = "choose Type"
  chooseCtegory: any = "choose Category"
  dateFrom: any = ''
  dateTo: any = ''
  name: any = ''
  categoryId: any = ''
  cat_arr: any
  pipe = new DatePipe('en-US');
  submitted = false
  constructor(private rest: GAccsessService, public dialogRef: MatDialogRef<MainComponent>, ) { }
  ngOnInit() {
    // this.gettaype()
  }


  gettaype(item: any) {
    this.rest.getStaffTypes(item).subscribe((res: any) => {
      console.log(res)
      this.cat_arr = res.children
      this.chooseType = item
    })
  }
  getCat(item: any) {
    this.chooseCtegory = item.name
    this.categoryId = item.id
  }
  addMemebr(form: any) {
    this.submitted = true
    console.log(form.valid)
    if (form.valid && this.categoryId != '') {
      let data = {
        name: this.name,
        valid_from: this.pipe.transform(this.dateFrom, 'YYYY-MM-dd'),
        valid_to: this.pipe.transform(this.dateTo, 'YYYY-MM-dd'),
        unit_relation_id: this.categoryId
      }

      this.dialogRef.close(data);
      console.log(data)
    }


  }

}
